import { Button as BloomButton, type ButtonProps as BloomButtonProps } from '@journ/bloom/button'
import { cn } from '@thom/libs/cn'

type ButtonSize = 'sm' | 'md' | 'icon'

type DistributiveOmit<T, K extends PropertyKey> = T extends unknown ? Omit<T, K> : never

type ButtonProps = DistributiveOmit<BloomButtonProps, 'size'> & { readonly size?: ButtonSize }

const sizes: Record<ButtonSize, string> = {
	sm: 'h-8 gap-x-1.5 px-3 py-0 text-xs/none sm:py-0 sm:text-xs/none [&>svg]:size-3.5 sm:[&>svg]:size-3.5',
	md: 'h-9 py-0 text-sm/none sm:py-0 sm:text-sm/none [&>svg]:size-4 sm:[&>svg]:size-4',
	icon: 'size-9 px-0 py-0 sm:py-0 [&>svg]:size-4 sm:[&>svg]:size-4',
}

const Button = ({ size = 'md', className, ...props }: ButtonProps) => (
	<BloomButton {...(props as BloomButtonProps)} className={cn(sizes[size], className)} />
)

export { Button }
export type { ButtonProps }
